<template>
  <nuttrema-layout-content>
    <nuttrema-empty-result icon="far fa-exclamation-triangle" slot="central">
      <template slot="text">
        <h1>{{ $t('label.error_403_title') }}</h1>
        <h4>{{ $t('label.error_403_text') }}</h4>
      </template>
    </nuttrema-empty-result>
  </nuttrema-layout-content>
</template>
<script>
import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import NuttremaEmptyResult from 'components/ui/panels/nuttrema-empty-result';

export default {
  name: 'page-403',
  components: {
    NuttremaLayoutContent,
    NuttremaEmptyResult,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/errors/page-403.vue